import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7dc0387e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-gray-01 px-3 py-2 mt-2 round-4" }
const _hoisted_2 = { class: "total-score d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "score-label text-mild text-size-12" }, "総合評価", -1))
const _hoisted_4 = { class: "score-point text-mild text-size-12" }
const _hoisted_5 = { class: "score-list border-top border-outline-color" }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "score-label text-mild text-size-12" }, "時間", -1))
const _hoisted_8 = { class: "score-point text-mild text-size-12" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "score-label text-mild text-size-12" }, "遂行", -1))
const _hoisted_11 = { class: "score-point text-mild text-size-12" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "score-label text-mild text-size-12" }, "挨拶", -1))
const _hoisted_14 = { class: "score-point text-mild text-size-12" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "score-label text-mild text-size-12" }, "コミュニケーション", -1))
const _hoisted_17 = { class: "score-point text-mild text-size-12" }
const _hoisted_18 = { class: "d-flex align-items-center" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "score-label text-mild text-size-12" }, "スキル", -1))
const _hoisted_20 = { class: "score-point text-mild text-size-12" }

import { computed } from "vue";
import type { PropType } from "vue";
import FiveStars from "@/components/molecules/other/FiveStars.vue";
import { EvaluationByOffice } from "@/types/order/EvaluationByOffice";
import { evaluationRound } from "@/utils/evaluationRound";


export default /*#__PURE__*/_defineComponent({
  __name: 'EvaluationGroup',
  props: {
  evaluation: {
    type: Object as PropType<EvaluationByOffice>,
    default: () => ({
      scorePunctuality: 0,
      scoreGreeting: 0,
      scoreCommunication: 0,
      scoreSkill: 0,
      scorePerformance: 0,
      avgEvaluation: 0
    })
  }
},
  setup(__props) {

const props = __props;



const filledStarImageSrc = computed(() =>
  require("@/assets/svg/star/filled_star_yellow.svg")
);
const filledStarHalfImageSrc = computed(() =>
  require("@/assets/svg/star/filled_star_half_yellow.svg")
);
const average = computed(() => {
  const avgEvaluation = props.evaluation.avgEvaluation;
  return evaluationRound(avgEvaluation);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createTextVNode(),
      _createVNode(FiveStars, {
        "filled-star-image-src": filledStarImageSrc.value,
        "filled-star-half-image-src": filledStarHalfImageSrc.value,
        value: average.value,
        size: "20"
      }, null, 8, ["filled-star-image-src", "filled-star-half-image-src", "value"]),
      _createTextVNode(),
      _createElementVNode("p", _hoisted_4, _toDisplayString(average.value) + "点\n      ", 1)
    ]),
    _createTextVNode(),
    _createElementVNode("ul", _hoisted_5, [
      _createElementVNode("li", _hoisted_6, [
        _hoisted_7,
        _createTextVNode(),
        _createVNode(FiveStars, {
          value: __props.evaluation.scorePunctuality,
          size: "14"
        }, null, 8, ["value"]),
        _createTextVNode(),
        _createElementVNode("p", _hoisted_8, _toDisplayString(__props.evaluation.scorePunctuality) + "点\n        ", 1)
      ]),
      _createTextVNode(),
      _createElementVNode("li", _hoisted_9, [
        _hoisted_10,
        _createTextVNode(),
        _createVNode(FiveStars, {
          value: __props.evaluation.scorePerformance,
          size: "14"
        }, null, 8, ["value"]),
        _createTextVNode(),
        _createElementVNode("p", _hoisted_11, _toDisplayString(__props.evaluation.scorePerformance) + "点\n        ", 1)
      ]),
      _createTextVNode(),
      _createElementVNode("li", _hoisted_12, [
        _hoisted_13,
        _createTextVNode(),
        _createVNode(FiveStars, {
          value: __props.evaluation.scoreGreeting,
          size: "14"
        }, null, 8, ["value"]),
        _createTextVNode(),
        _createElementVNode("p", _hoisted_14, _toDisplayString(__props.evaluation.scoreGreeting) + "点\n        ", 1)
      ]),
      _createTextVNode(),
      _createElementVNode("li", _hoisted_15, [
        _hoisted_16,
        _createTextVNode(),
        _createVNode(FiveStars, {
          value: __props.evaluation.scoreCommunication,
          size: "14"
        }, null, 8, ["value"]),
        _createTextVNode(),
        _createElementVNode("p", _hoisted_17, _toDisplayString(__props.evaluation.scoreCommunication) + "点\n        ", 1)
      ]),
      _createTextVNode(),
      _createElementVNode("li", _hoisted_18, [
        _hoisted_19,
        _createTextVNode(),
        _createVNode(FiveStars, {
          value: __props.evaluation.scoreSkill,
          size: "14"
        }, null, 8, ["value"]),
        _createTextVNode(),
        _createElementVNode("p", _hoisted_20, _toDisplayString(__props.evaluation.scoreSkill) + "点\n        ", 1)
      ])
    ])
  ]))
}
}

})